import './style/index.less';
import MapVector from './MapVector';

export default MapVector;
